<template>
  <v-layout column align-center v-scroll="searchMore">
    <v-col
      cols="9"
      md="9"
      lg="9"
      xl="9"
      sm="12"
      xs="2"
      xm="2"
      class="mt-8 ml-0"
    >
      <div id="main">
        <v-row :class="{ 'ml-n12': $vuetify.breakpoint.mdAndUp }">
          <span
            class="mb-7 text-right display-1 font-weight-bold grey--text text--darken-1"
          >
            {{ $vuetify.lang.t("$vuetify.POOLS_VIRTUAIS") }}</span
          >
        </v-row>

        <v-row id="filtro" class="pl-2 ml-0 grey lighten-5">
          <v-col cols="4" class="mr-0 pl-4 pr-8">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="searchText"
                dense
                label="Regular"
                :placeholder="$vuetify.lang.t('$vuetify.NOME_POOL_OU_CONTRATO')"
                single-line
                solo
                append-icon="mdi-magnify"
                @click:append="search()"
                @keypress.enter="search()"
              ></v-text-field>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="pl-2 pr-2" style="margin-left: -2px">
          <v-expansion-panels class="ma-1">
            <v-expansion-panel
              v-for="(pool, i) in pools"
              :key="i"
              hide-actions
              :disabled="disabled"
            >
              <v-expansion-panel-header v-slot="{ open }" style="z-index: 1000">
                <v-row align="center" no-gutters>
                  <v-col v-show="!$vuetify.breakpoint.xs" sm="5" md="4">
                    <strong
                      class="subtitle-2 font-weight-bold"
                      v-html="pool.nome"
                    ></strong>
                  </v-col>
                  <v-spacer></v-spacer>

                  <v-chip
                    v-if="!open"
                    color="blue darken-2"
                    class="ml-0 mr-3"
                    label
                    small
                    outlined
                  >
                    {{
                      formatSize(pool.consumoGB) +
                      " / " +
                      formatSize(pool.tamanhoGB)
                    }}
                  </v-chip>
                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="2" class="ml-3">
                    <v-row sm="1">
                      <v-chip
                        v-if="!open"
                        color="blue darken-2"
                        class="ml-0 mr-3"
                        label
                        small
                        outlined
                      >
                        {{
                          formatSize(pool.consumoGB) +
                          " / " +
                          formatSize(pool.tamanhoGB)
                        }}
                      </v-chip>
                    </v-row>
                  </v-col>

                  <v-col class="mt-2 ml-12">
                    <v-row
                      class="mt-0 ml-1"
                      :class="{ 'pl-10 pt-3 ml-n5': $vuetify.breakpoint.xs }"
                    >
                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-4 ml-n3"
                        :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.CONTRATO')"
                          :value="pool.contrato ? pool.contrato.nome : '--'"
                          justify="start"
                          style="width: 350px"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-4 ml-n3"
                        :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.ESTRANGULAR_BANDA')"
                          :value="pool.estrangularBanda ? $vuetify.lang.t('$vuetify.YES') : $vuetify.lang.t('$vuetify.NAO')"
                          justify="start"
                          style="width: 350px"
                          truncate
                        ></LabelValue>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-divider class="mt-0"></v-divider>

                <v-card-actions class="mb-n3">
                  <TooltipButton
                    :label="$vuetify.lang.t('$vuetify.CIRCUITOS')"
                    :message="$vuetify.lang.t('$vuetify.LISTAR_CIRCUITOS')"
                    :event="listCircuits"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText="true"
                    :object="pool"
                    :loading="circuitsLoading"
                  ></TooltipButton>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>

        <v-row justify="center">
          <v-progress-circular
            v-if="isLoading"
            :size="40"
            :width="4"
            color="error"
            indeterminate
            class="ml-n2 mt-3 mb-n1 text-center"
          ></v-progress-circular>
        </v-row>
        <v-row justify="center" v-if="pools.length == 0 && !isLoading">
          <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
            <WarningPanel
              v-if="!isLoading"
              :message="$vuetify.lang.t('$vuetify.NENHUM_POOL_VIRTUAL_ENCONTRADO')"
            >
            </WarningPanel>
          </v-lazy>
        </v-row>
      </div>
    </v-col>

    <VirtualPoolCircuitsDialog
      :dialog="showCircuitsList"
      :pool="selectedPool"
      :close="closeCircuitsList"
      :circuits="circuits"
    >
    </VirtualPoolCircuitsDialog>
  </v-layout>
</template>

<script>
import WarningPanel from "../components/panels/WarningPanel";
import TooltipButton from "../components/TooltipButton";
import LabelValue from "../components/LabelValue";
import VirtualPoolCircuitsDialog from "../components/dialogs/VirtualPoolCircuitsDialog";

export default {
  components: {
    WarningPanel,
    TooltipButton,
    LabelValue,
    VirtualPoolCircuitsDialog,
  },
  methods: {
    listCircuits(pool) {
      this.selectedPool = pool;
      this.circuitsLoading = true;
      this.$get("/circuito/pool", { poolId: pool.id }).then((response) => {
        this.circuits = response.data;
        this.showCircuitsList = true;
        this.circuitsLoading = false;
      });
    },
    closeCircuitsList() {
      this.showCircuitsList = false;
    },
    formatSize(sizeGB) {
      if (!sizeGB || sizeGB == 0) return "0";

      const units = ["GB", "TB", "PB"];
      let value = sizeGB;
      let unitIndex = 0;

      while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex++;
      }

      return value.toFixed(2) + " " + units[unitIndex];
    },
    exportCSV() {
      this.loadingExport = true;
      if (!this.allPools || this.allPools.length == 0) {
        this.$get("/pool-virtual/all", {
          searchText: this.searchText,
        }).then((response) => {
          this.allPools = response.data.map((p) => {
            p.designacao_tpz =
              p.circuitos && p.circuitos.length > 0
                ? p.circuitos[0].designacaoTpz
                : "--";
            p.contrato = p.contrato ? p.contrato.nome : "";
            return p;
          });

          this.$downloadCSV(this.allPools, this.$vuetify.lang.t("$vuetify.POOLS_VIRTUAIS"));
          this.loadingExport = false;
        });
      } else {
        this.$downloadCSV(this.allPools, this.$vuetify.lang.t("$vuetify.POOLS_VIRTUAIS"));
        this.loadingExport = false;
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.isLoading = false;
      this.message = undefined;
    },
    searchMore() {
      this.stickFilters();

      if (this.isLoding || this.noResult) {
        return;
      }

      if (
        document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.scrollHeight
      ) {
        this.page++;
        this.search(this.page);
      }
    },
    search(page) {
      this.isLoading = true;
      if (!page) {
        this.page = 0;
        this.pools = [];
        this.noResult = false;
        this.allRequests = undefined;
      }

      this.$get("/pool-virtual/busca", {
        searchText: this.searchText,
        contractId: window.sessionStorage.getItem("selectedContractId"),
        page: this.page,
      }).then((response) => {
        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.pools = this.pools.concat(response.data);
        this.isLoading = false;
      });
    },
    stickFilters() {
      if (document.documentElement.scrollTop > 95) {
        document.getElementById("filtro").style =
          "position:sticky; z-index:2; top:66px; box-shadow: 0 0 10px #333; border-radius: 15px;";
      } else if (document.documentElement.scrollTop < 60) {
        document.getElementById("filtro").style = "";
      }
    },
  },
  data: () => ({
    associateLoading: false,
    associateDialog: false,
    action: undefined,
    circuitsLoading: false,
    circuits: [],
    showCircuitsList: false,
    loadingExport: false,
    page: 0,
    isLoading: false,
    noResult: false,
    searchText: "",
    pools: [],
    showDialog: false,
    disabled: false,
    selectedPool: {},
    message: undefined,
    infoDialog: false,
    circuitsDialog: false,
  }),
  created: function () {
    this.isLoading = true;
    this.$get("/pool-virtual/busca", { searchText: undefined, contractId: window.sessionStorage.getItem("selectedContractId"), page: 0 }).then(
      (response) => {
        this.pools = this.pools.concat(response.data);
        this.isLoading = false;
      }
    );
  },
};
</script>
